var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('label',{class:_vm.classLabel},[_vm._v(_vm._s(_vm.description))]),_c('div',{class:_vm.classValue},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }